var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Add(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-add",
    d: "M14,4A10,10,0,1,0,24,14,10.011,10.011,0,0,0,14,4Zm0,1.5A8.5,8.5,0,1,1,5.5,14,8.489,8.489,0,0,1,14,5.5Zm-.012,3.489a.75.75,0,0,0-.738.761v3.5H9.75a.75.75,0,1,0,0,1.5h3.5v3.5a.75.75,0,1,0,1.5,0v-3.5h3.5a.75.75,0,1,0,0-1.5h-3.5V9.75a.75.75,0,0,0-.762-.761Z",
    transform: "translate(-4 -4)",
    fill: "#ec6a49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Add);
export default __webpack_public_path__ + "static/media/icons8-add.83377a932a3d6148d53fc492446644cc.svg";
export { ForwardRef as ReactComponent };